import Raven from "raven-js";
import { version } from "../package.json";
// import { getInstance } from "./logRocket.config";
/* import * as Sentry from '@sentry/browser'; */

const SENTRY_KEY = "8a0ae2d10ef04f00af170d9721c252a3";
const SENTRY_APP = "1882320";
export const SENTRY_URL = `https://59af82ca8fa84fa28655ba27dec55b7d@sentry.io/1537128`;

const ignoreErrorsArray = [
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "ResizeObserver loop completed with undelivered notifications",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // Generic error code from errors outside the security sandbox
  // You can delete this if using raven.js > 1.0, which ignores these automatically.
  "Script error.",
  `Uncaught (in promise) Error: Error parsing handshake response: Error: Expected a handshake response from the server.`,
  `'ResizeObserver' is not defined`,
  "WebSocket closed with status code: 1006 ()",
  "Failed to fetch",
  "Error parsing handshake response: Error: Expected a handshake response from the server.",
  "Invocation canceled due to connection being closed.",
  "Server returned handshake error: Handshake was canceled.",
  "Server timeout elapsed without receiving a message from the server.",
  "Cannot send data if the connection is not in the 'Connected' State.",
];
const ignoreUrlsArray = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];
function getUser() {
  let user = localStorage.getItem("user");
  if (user) user = JSON.parse(user);
  else return "NoUser";

  if (user.userGuid) return user.userGuid;
  else return "NoUser";
}
function configSentry() {
  if (process?.env?.NODE_ENV?.toLowerCase() === "production") {
    // var logRocket = getInstance();
    // Raven.setDataCallback((data) => {
    //   data.extra.sessionURL = logRocket.sessionURL;
    // });
    return Raven.config(SENTRY_URL, {
      release: version,
      stacktrace: true,
      ignoreErrors: ignoreErrorsArray,
      ignoreUrls: ignoreUrlsArray,
      allowUrls: [/https?:\/\/(www\.)?jirango\.com/],
      environment: process.env.NODE_ENV,
      extra: {
        user: getUser(),
      },
    }).install();
  }
}

export function logException(ex, context) {
  Raven.captureException(ex, { extra: context, stacktrace: true });
  window && window.console && console.error && console.error(ex);
}

export default configSentry();
